'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

require('rp-jquery-modal-dropdown');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTROL_SELECTOR = '#js-menuBarSearch';
var CONTROL_INPUT_SELECTOR = '.rn-menuBar__navItem__search__input';
var DROPDOWN_INPUT_SELECTOR = '.rn-searchPopoverInput';

var SEARCH_VALUE_STORAGE_KEY = 'nav_search_value';

var URI_SEARCH = '/search.json';
// const URI_SUGGEST = '/suggest.json';

var getBaseURL = function getBaseURL() {
    var base_url_ = (0, _jquery2.default)('.rn-menuBar__logo__link').attr('href');

    if (base_url_ == undefined) // during tests it is undefined!
        {
            return base_url_ = '';
        }

    base_url_ = base_url_.replace(/\/$/, ''); // without trailing slash

    return base_url_;
};

var BASE_URL = getBaseURL();

var DROPDOWN_CONFIG = {
    id: 'search-dropdown',
    autoOpen: false,
    position: {
        my: 'right top',
        at: 'right bottom',
        collision: 'fit none'
    },
    keepVertically: true,
    origin: 'rn-searchPopover',
    openedCssClass: 'rn-menuBar__navItem_active',
    cssClass: 'rn-searchPopover_start',
    tmpl: '<div class="ui-popoverPointer"></div>\n           <div class="rn-searchPopoverHeader ui-popoverHeader">\n                <input type="text" class="ui-input rn-searchPopoverInput" placeholder="Search">\n                <svg class="rn-searchPopoverCloseIcon ui-icon ui-icon_sizeMedium">\n                    <use xlink:href="#icon-cross"/>\n                </svg>\n                <svg class="rn-searchPopoverSearchIcon ui-icon">\n                    <use xlink:href="#icon-search-button"/>\n                </svg>\n           </div>',
    backdrop: 'rn-overlay_toNarrow',
    backdropFrom: '.rn-menuBar',
    content: '<div class="rn-searchPopoverContent hidden"></div>'
};

/**
 * Due to functionality restrictions of rp-jquery-modal-dropdown plugin
 * we use this hack to close BetSlip
 * when user click on a Search input
 */
var closeBetSlip = function closeBetSlip() {
    var $betSlipCloseBtns = [(0, _jquery2.default)('.js-betSlipDoneBtn'), (0, _jquery2.default)('.js-BetSlipPlaceHolder > .closePopup')];
    $betSlipCloseBtns.forEach(function ($button) {
        if ($button.is(':visible')) {
            $button.trigger('click');
        }
    });
};

var Search = function () {
    (0, _createClass3.default)(Search, null, [{
        key: 'breakInteger',
        value: function breakInteger(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }, {
        key: 'storeSearchValue',
        value: function storeSearchValue(value) {
            return sessionStorage.setItem(SEARCH_VALUE_STORAGE_KEY, value);
        }
    }, {
        key: 'getStoredSearchValue',
        value: function getStoredSearchValue() {
            return sessionStorage.getItem(SEARCH_VALUE_STORAGE_KEY);
        }
    }, {
        key: 'renderHorseProfileLinkContent',
        value: function renderHorseProfileLinkContent(title) {
            var _ref = /^(.+) \((\w+)\) - (\d\d\d\d)$/g.exec(title) || [],
                _ref2 = (0, _slicedToArray3.default)(_ref, 4),
                _ref2$ = _ref2[1],
                name = _ref2$ === undefined ? title : _ref2$,
                _ref2$2 = _ref2[2],
                country = _ref2$2 === undefined ? '' : _ref2$2,
                _ref2$3 = _ref2[3],
                year = _ref2$3 === undefined ? '' : _ref2$3;

            return '<span>\n                ' + name + '\n                <span class="rn-searchPopoverList__link_horseOrig">\n                    (' + country + ') - ' + year + '\n                </span>\n            </span>';
        }
    }, {
        key: 'renderProfilesLinks',
        value: function renderProfilesLinks(searchQuery, profileType, data) {
            var titleRenderer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (title) {
                return title;
            };

            var list = '';
            if (data.record_count > 0) {
                list = data.records && data.records.page.map(function (profile) {
                    return '<li class="rn-searchPopoverInnerList__item">\n                        <a\n                            href="' + profile.url + '"\n                            class="ui-link ui-link_primary rn-searchPopoverList__link rn-searchPopoverList__link_innerList js-popupLink"\n                        >\n                            <span class="rn-searchPopoverList__itemLabel">\n                                ' + titleRenderer(profile.title) + '\n                            </span>\n                        </a>\n                    </li>';
                }).join('\n');

                if (data.info.page.total_result_count > 5) {
                    list += '<li class="rn-searchPopoverInnerList__item rn-searchPopoverInnerList__item_seeAll">\n                    <a\n                        href="' + BASE_URL + '/search/?tab=profiles&profiles_type=' + profileType + '&query=' + encodeURIComponent(searchQuery) + '"\n                        class="rn-searchPopover__button ui-btn ui-btn_primary"\n                    >\n                        See all matches\n                    </a>\n                </li>';
                }
            }

            return '<ul class="rn-searchPopoverInnerList">\n                    <li><span class="rn-searchPopoverInnerList__topMatches">Top matches</span></li>\n                    ' + list + '\n                </ul>';
        }
    }, {
        key: 'renderProfiles',
        value: function renderProfiles(facets, searchQuery) {
            facets = (0, _assign2.default)({
                profiles: 0,
                horses_profiles: 0,
                trainers_profiles: 0,
                owners_profiles: 0,
                jockeys_profiles: 0,
                courses: 0,
                stories: 0
            }, facets);

            var iconRigthTmpl = '<svg class="rn-searchPopoverList__linkIcon ui-icon ui-icon_sizeMedium">\n                <use xlink:href="#icon-down"/>\n            </svg>';

            var renderListItem = function renderListItem(type, label) {
                return '<div class="rn-searchPopoverList__item">\n                <a\n                    href="' + BASE_URL + '/search/?profile=' + type + '&query=' + encodeURIComponent(searchQuery) + '"\n                    class="rn-searchPopoverList__link"\n                    data-profile-type="' + type + '"\n                    data-disabled="' + (!facets[type] ? 'true' : 'false') + '"                    \n                >\n                    <span class="rn-searchPopoverList__linkLabel">' + label + '</span>\n                    <span class="rn-searchPopoverList__linkCounter">' + facets[type] + '</span>\n                    ' + iconRigthTmpl + '\n                </a>                                                        \n            </div>';
            };

            return '<div class="rn-searchPopover__profile">\n                    <h2 class="rn-searchPopoverContent__header">\n                        Profiles\n                    </h2>\n                    <div class="rn-searchPopoverList">\n                        <div class="rn-searchPopoverList__itemBlock">\n                            ' + renderListItem('horses_profiles', 'Horses') + '\n                            ' + renderListItem('jockeys_profiles', 'Jockeys') + '\n                            ' + renderListItem('trainers_profiles', 'Trainers') + '\n                        </div>\n                        <div class="rn-searchPopoverList__itemBlock">\n                            ' + renderListItem('owners_profiles', 'Owners') + '\n                            ' + renderListItem('courses', 'Courses') + '\n                        </div>\n                    </div>\n                </div>\n                <div class="rn-searchPopover__stories">\n                    <h2 class="rn-searchPopoverContent__header">\n                        Stories&nbsp;\n                        <span class="rn-searchPopoverContent__counter">\n                            ' + Search.breakInteger(facets.stories) + '\n                        </span>\n                    </h2>';
        }
    }, {
        key: 'renderNotFound',
        value: function renderNotFound() {
            return '<span class="rn-searchPopoverContent__message">No matches were found</span>';
        }
    }, {
        key: 'renderSpinner',
        value: function renderSpinner() {
            return '<div class="rn-searchPopover__spinnerContainer">\n                <svg class="ui-animation_spinnerAnimation ui-icon ui-icon_size2XL">\n                    <use xlink:href="#icon-spinner"></use>\n                </svg>\n            </div>';
        }
    }]);

    function Search() {
        (0, _classCallCheck3.default)(this, Search);

        this.$control = (0, _jquery2.default)(CONTROL_SELECTOR);
        this.$controlInput = this.$control.find(CONTROL_INPUT_SELECTOR);
        this.handleCursorVisibilityInIE(this.$controlInput);

        this.engineKey = this.$control.data('engine-key');
        this.engineBaseUrl = this.$control.data('engine-url');

        this.$content = null;

        this.search = (0, _debounce2.default)(this.search, 400);

        this.initModalDropdown();

        this.initInputsValues();
    }

    (0, _createClass3.default)(Search, [{
        key: 'handleCursorVisibilityInIE',
        value: function handleCursorVisibilityInIE($control) {
            var handleWindowResize = (0, _debounce2.default)(function () {
                if ($control.is(':hidden')) {
                    $control.blur();
                }
            }, 100);

            $control.on('focus', function () {
                (0, _jquery2.default)(window).on('resize', handleWindowResize);
            });

            $control.on('blur', function () {
                (0, _jquery2.default)(window).off('resize', handleWindowResize);
            });
        }
    }, {
        key: 'initModalDropdown',
        value: function initModalDropdown() {
            var _this = this;

            if (!this.$control.rpModalDropDown) {
                throw Error('Search component does not work without jquery-modal-dropdown. \n                        Missing jQuery.fn.rpModalDropDown');
            }

            this.$control.on('click touchstart', function (e) {
                _this.$controlInput.is(':visible') && e.stopImmediatePropagation();
            });
            this.$control.rpModalDropDown(DROPDOWN_CONFIG);

            (0, _jquery2.default)(window).on('resize', function () {
                if (_this.$controlInput.is(':visible') && _this.$dropdownInput.val().length < 3) {
                    _this.$control.rpModalDropDown('close');
                }
            });

            // TODO: all these events are triggered on the $control, not the $dropdown
            // But we can't just switch them on, because it breaks current search logic
            this.$dropdown = (0, _jquery2.default)('#search-dropdown').on('show.modalDropdown-search-dropdown', this.onShow()).on('hide.modalDropdown-search-dropdown', this.onHide());

            this.$control.on('shown.modalDropdown-search-dropdown', this.onShown());

            this.$dropdownInput = this.$dropdown.find(DROPDOWN_INPUT_SELECTOR).on('input propertychange', this.onInputDropdown());
            this.handleCursorVisibilityInIE(this.$dropdownInput);

            this.$dropdown.find('.rn-searchPopoverCloseIcon').on('click touchstart', function () {
                _this.$dropdownInput.val('');
                _this.doSearch(_this.$dropdownInput.val());
            });

            this.$controlInput.on('click touchstart', function (e) {
                e.stopPropagation();
                closeBetSlip();
            }).on('input propertychange', this.onInputControl()).on('focus', this.onFocusControl());
        }
    }, {
        key: 'initInputsValues',
        value: function initInputsValues() {
            var value = Search.getStoredSearchValue();

            this.$controlInput.val(value);
            this.$dropdownInput.val(value);
        }
    }, {
        key: 'doRequest',
        value: function doRequest(uri, params) {
            var _this2 = this;

            return new _promise2.default(function (resolve, reject) {
                _jquery2.default.ajax({
                    method: 'post',
                    url: _this2.engineBaseUrl + uri,
                    data: (0, _assign2.default)({}, {
                        engine_key: _this2.engineKey
                    }, params),
                    crossDomain: true
                }).done(function (data) {
                    resolve(data);
                }).fail(function () {
                    reject('Search error');
                });
            });
        }
    }, {
        key: 'search',
        value: function search(searchQuery) {
            var profiles = this.doRequest(URI_SEARCH, {
                q: searchQuery.trim(),
                per_page: 5,
                facets: {
                    page: ['type', 'profiles_type']
                },
                fetch_fields: {
                    page: ['title']
                }
            });

            var stories = this.doRequest(URI_SEARCH, {
                q: searchQuery.trim(),
                per_page: 5,
                filters: {
                    page: {
                        type: 'stories'
                    }
                },
                fetch_fields: {
                    page: ['title', 'url']
                }
            });

            _promise2.default.all([profiles, stories]).then(this.onSearchSuccess(searchQuery)).catch(this.onSearchFail());
        }
    }, {
        key: 'searchProfile',
        value: function searchProfile(searchQuery, profileType) {
            var profiles = this.doRequest(URI_SEARCH, {
                q: searchQuery.trim(),
                per_page: 5,
                filters: {
                    page: {
                        type: ['profiles', 'course'],
                        profiles_type: profileType
                    }
                },
                fetch_fields: {
                    page: ['title', 'url']
                }
            });

            profiles.then(this.onProfileSearchSuccess(searchQuery, profileType)).catch(this.onProfileSearchFail());
        }
    }, {
        key: 'onSearchSuccess',
        value: function onSearchSuccess(searchQuery) {
            var _this3 = this;

            var self = this;
            return function (data) {
                var content = Search.renderProfiles((0, _assign2.default)({}, data[0].info.page.facets.profiles_type, data[0].info.page.facets.type), searchQuery);

                if (data[1].record_count === 0) {
                    content += Search.renderNotFound();
                } else {
                    var stories = data[1].records.page;
                    content += '<ul class="rn-searchPopoverList">';

                    _jquery2.default.each(stories, function (index, story) {
                        content += '<li class="rn-searchPopoverList__item">\n                            <a\n                                href="' + story.url + '"\n                                class="rn-searchPopoverList__link"\n                            >\n                                <span class="rn-searchPopoverList__itemLabel">' + story.title + '</span>\n                            </a>\n                        </li>';
                    });

                    content += '</ul>';
                }

                if (data[1].info.page.total_result_count > 5) {
                    content += '<div class="rn-searchPopover__buttonContainer">\n                        <a \n                            href="' + BASE_URL + '/search/?tab=stories&query=' + encodeURIComponent(searchQuery) + '"\n                            class="rn-searchPopover__button ui-btn ui-btn_primary"\n                        >\n                            See all matches\n                        </a>\n                    </div>\n                </div>';
                }

                _this3.getContent().html(content);

                _this3.getContent().find('[data-profile-type]').on('click', function (event) {
                    event.preventDefault();

                    var element = (0, _jquery2.default)(this);
                    if (element.data('disabled')) {
                        return;
                    }

                    element.closest('.rn-searchPopoverList').find('.rn-searchPopoverList__link.opened').removeClass('opened');

                    element.addClass('opened');

                    if (element.next().length > 0) {
                        element.next().remove();
                        element.removeClass('opened');
                        return;
                    }

                    element.closest('.rn-searchPopoverList').find('.rn-searchPopoverInnerList').remove();
                    element.after(Search.renderSpinner());
                    self.searchProfile(searchQuery, element.data('profile-type'));
                });

                _this3.getContent().find('[data-profile-type="horses_profiles"]').click();
            };
        }
    }, {
        key: 'onProfileSearchSuccess',
        value: function onProfileSearchSuccess(searchQuery, profileType) {
            var _this4 = this;

            return function (data) {
                var listItem = _this4.getContent().find('[data-profile-type="' + profileType + '"]');

                // hide spinner
                listItem.next().remove();

                listItem.after(Search.renderProfilesLinks(searchQuery, profileType, data, profileType === 'horses_profiles' ? Search.renderHorseProfileLinkContent : undefined));
            };
        }
    }, {
        key: 'onProfileSearchFail',
        value: function onProfileSearchFail() {
            return function () {
                console.log('Fail');
            };
        }
    }, {
        key: 'onSearchFail',
        value: function onSearchFail() {
            var _this5 = this;

            return function () {
                var content = Search.renderProfiles() + Search.renderNotFound();
                _this5.getContent().html(content);
            };
        }
    }, {
        key: 'onInputDropdown',
        value: function onInputDropdown() {
            var _this6 = this;

            return function (event) {
                var inputVal = event.target.value;

                Search.storeSearchValue(inputVal);

                _this6.$controlInput.val(inputVal);
                _this6.doSearch(inputVal);
            };
        }
    }, {
        key: 'onFocusControl',
        value: function onFocusControl() {
            var _this7 = this;

            return function () {
                var value = _this7.$controlInput.val();

                if (value && value.length >= 3) {
                    closeBetSlip();
                    _this7.$control.rpModalDropDown('open');
                    _this7.doSearch(value);
                }
            };
        }
    }, {
        key: 'onInputControl',
        value: function onInputControl() {
            var _this8 = this;

            return function (event) {
                var inputVal = event.target.value;

                Search.storeSearchValue(inputVal);

                _this8.$dropdownInput.val(inputVal);

                if (inputVal.length >= 3) {
                    closeBetSlip();
                    _this8.$control.rpModalDropDown('open');
                } else {
                    _this8.$control.rpModalDropDown('close');
                }

                _this8.doSearch(event.target.value);
            };
        }
    }, {
        key: 'doSearch',
        value: function doSearch(searchQuery) {
            if (searchQuery !== this.searchQueryOld) {
                this.searchQueryOld = searchQuery;

                if (searchQuery.length >= 3) {
                    this.showSpinner().showSearchResultsPlaceholder().search(searchQuery);
                } else {
                    this.hideSpinner().hideSearchResultsPlaceholder();
                }
            }
        }
    }, {
        key: 'getContent',
        value: function getContent() {
            if (!this.$content || this.$content.length === 0) {
                this.$content = this.$dropdown.find('.rn-searchPopoverContent');
            }
            return this.$content;
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            var _this9 = this;

            return function () {
                _this9.$dropdownInput.val('');
                _this9.getContent().html('').addClass('hidden');
            };
        }
    }, {
        key: 'onShown',
        value: function onShown() {
            var _this10 = this;

            return function () {
                _this10.$dropdownInput.focus();

                var value = _this10.$dropdownInput.val();
                if (value && value.length >= 3) {
                    _this10.doSearch(value);
                }
            };
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            var _this11 = this;

            return function () {
                _this11.hideSpinner().hideSearchResultsPlaceholder();
            };
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            var _this12 = this;

            return function () {
                _this12.$control.rpModalDropDown('close');
            };
        }
    }, {
        key: 'showSpinner',
        value: function showSpinner() {
            this.getContent().html(Search.renderSpinner());
            return this;
        }
    }, {
        key: 'hideSpinner',
        value: function hideSpinner() {
            this.getContent().html('');
            return this;
        }
    }, {
        key: 'showSearchResultsPlaceholder',
        value: function showSearchResultsPlaceholder() {
            this.$dropdown.removeClass('rn-searchPopover_start');
            this.getContent().removeClass('hidden');
            return this;
        }
    }, {
        key: 'hideSearchResultsPlaceholder',
        value: function hideSearchResultsPlaceholder() {
            this.$dropdown.addClass('rn-searchPopover_start');
            this.getContent().addClass('hidden');
            return this;
        }
    }]);
    return Search;
}();

exports.default = Search;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/search/search.js
// module id = 1470
// module chunks = 1